// A bordered panel with a small label that sits inline on the top border,
// breaking the line (like a fieldset legend), instead of a full header bar.
function SectionBlock({ title, children }) {
  return (
    <div className="relative mx-1 mb-4 rounded-2xl border border-white/15">
      <span className="absolute -top-1.5 left-4 px-2 bg-nlg-bg rounded text-xs leading-none font-bold uppercase tracking-wider text-nlg-cream">
        {title}
      </span>
      <div className="bg-nlg-block rounded-2xl overflow-hidden pt-1">
        {children}
      </div>
    </div>
  );
}

export default SectionBlock;
